import { TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatError,MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { Status, TFolder } from '@core/interfaces/Endpoints';

import { FoldersService } from '@shared/services/folders.service';

import { allowedStatuses } from '../../../../enums/status';

@Component({
    selector: 'app-new-folder-modal',
    templateUrl: './new-folder-modal.component.html',
    styleUrls: ['./new-folder-modal.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatSelect, MatOption, MatButton, TitleCasePipe]
})
export class NewFolderModalComponent {
  public newFolderForm = this.fb.nonNullable.group({
    name: ['', [Validators.required]],
    status: ['', [Validators.required]],
  });

  statuses = allowedStatuses;

  constructor(
    private dialogRef: MatDialogRef<NewFolderModalComponent>,
    private fb: FormBuilder,
    private _folderService: FoldersService
  ) {}

  public get name() {
    return this.newFolderForm.get('name')!;
  }

  public get status() {
    return this.newFolderForm.get('status')!;
  }

  public addNewItem(): void {
    if (this.newFolderForm.valid) {
      const newFolderItem: TFolder = {
        name: this.name.value ?? ``,
        status: (this.status.value ?? Status.Inactive) as unknown as TFolder['status'],
      };
      this._folderService.addNewFolder(newFolderItem, () => this.dialogRef.close());
    }
  }
}
